import { SchoolDetailInstructorInputType } from '../../type/Instructor/SchoolDetailInstructorNew.type';

export const schoolDetailInstructorInputInitial: SchoolDetailInstructorInputType = {
    name: '',
    description: '',
    deletingImage: false,
    image: null,
}